<adapt-dialog [maxWidth]="800">
    <h3 adapt-dialog-title>Add new coach partner</h3>

    <div adapt-dialog-content>
        <div class="d-flex flex-row justify-content-between mx-4 mb-3">
            @for (stepName of stepNames; track stepName; let i = $index; let last = $last) {
                <div class="align-self-center d-flex">
                    <span class="align-self-baseline"
                          [ngClass]="{
                            'step-index': i === currentStepIndex,
                            'step-index-disabled': i !== currentStepIndex,
                        }">{{ i + 1 }}</span>
                    <span class="ms-2 align-self-baseline"
                          [ngClass]="i === currentStepIndex ? 'step-text' : 'step-text-disabled'">{{ stepName }}</span>
                </div>
                @if (!last) {
                    <div class="align-self-center d-flex flex-grow-1 step-separator">&nbsp;</div>
                }
            }
        </div>

        @if (error) {
            <div role="alert"
                 class="alert alert-danger">
                {{ error }}
            </div>
        }

        @if (completed) {
            <div role="alert"
                 class="alert alert-primary">Coach added successfully.</div>
        }

        <div class="mt-4 p-3 pt-0">
            @switch (currentStep) {
                @case (StepName.SetPerson) {
                    <adapt-new-coach-person [(person)]="person"
                                            (personChange)="onPersonChange($event)"
                                            [(temporaryPerson)]="temporaryPerson"></adapt-new-coach-person>
                }
                @case (StepName.CoachDetails) {
                    <adapt-new-coach-details [practitioner]="practitioner"></adapt-new-coach-details>
                }
                @case (StepName.SetSandbox) {
                    <adapt-new-coach-sandbox [(createdOrganisation)]="createdOrganisation"
                                             [(joinOrganisation)]="joinOrganisation"
                                             [(coachRoleTypeCodes)]="coachRoleTypeCodes"></adapt-new-coach-sandbox>
                }
                @case (StepName.Confirmation) {
                    <adapt-new-coach-confirmation [completed]="completed"
                                                  [person]="person"
                                                  [temporaryPerson]="temporaryPerson"
                                                  [practitioner]="practitioner"
                                                  [createdOrganisation]="createdOrganisation"
                                                  [joinOrganisation]="joinOrganisation"
                                                  [coachRoleTypeCodes]="coachRoleTypeCodes"></adapt-new-coach-confirmation>
                }
            }
        </div>
    </div>

    <div adapt-dialog-footer
         adaptBlockingButtonGroup
         class="ms-auto">
        @if (!completed) {
            <button adaptButtonIcon="fal fa-fw fa-arrow-circle-left"
                    (click)="previous()"
                    [disabled]="currentStepIndex < 1">Previous</button>
            <button adaptButtonIcon="fal fa-fw fa-arrow-circle-right"
                    (click)="next()"
                    [disabled]="!canGoNext || currentStepIndex >= stepNames.length - 1">Next</button>
            @if (isCurrentStep(StepName.Confirmation)) {
                <button adaptButtonIcon="fal fa-fw fa-plus-square"
                        [adaptBlockingClick]="addCoach">Add new coach partner</button>
            }
        }
        <button adaptButtonIcon="cancel"
                [adaptBlockingClick]="cancel">
            {{ completed ? "Close" : "Cancel" }}
        </button>
    </div>
</adapt-dialog>
